import { computed } from "vue";


export const closeExternalPwaWindow = () => {
  window.close()
}
export const isPWA = computed(() => {
  const navigator: any = window.navigator
  return (window.matchMedia('(display-mode: standalone)').matches) || navigator.standalone;
})